import api from 'api'
import { CACHE_TAG_ACCOUNT_GROUP_DETAILS, CACHE_TAG_ACCOUNT_GROUP_SUMMARY_DETAILS } from '../../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addAccountsToGroup: build.mutation({
      query: ({ accountGroupId, accounts }) => ({
        url: `/api/v1/core/accounts/groups/${accountGroupId}:add-accounts`,
        body: { accounts },
        method: 'PUT',
      }),
      invalidatesTags: (result, error, arg) => {
        const { accountGroupId } = arg
        return [
          { type: CACHE_TAG_ACCOUNT_GROUP_DETAILS, id: accountGroupId },
          { type: CACHE_TAG_ACCOUNT_GROUP_SUMMARY_DETAILS, id: accountGroupId },
        ]
      },
    }),
  }),
})

export const { useAddAccountsToGroupMutation } = extendedApi
